






















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class DialogDeleteConfirm extends Vue {
  @Prop({ default: '' }) title: string

  confimDialog = false

  onDelete() {
    this.$emit('confirmed')
    this.confimDialog = false
  }
}
